import { create, StoreApi, UseBoundStore } from 'zustand';
import { createAPIInstance } from '@/context/global/utils/api/api-create';
import { CreateAPI } from '@/context/global/api';
import { getCookie } from 'cookies-next';
import { useAuthStore } from '@/context/global/stores/authStore';

type WrappedAPI = ReturnType<typeof CreateAPI>;

interface ApiState {
  API: WrappedAPI;

  setAPI: (newAPI: WrappedAPI) => void;
}

export const useApiStore: UseBoundStore<StoreApi<ApiState>> = create<ApiState>((set) => {
  const { token } = useAuthStore.getState();

  const locale = getCookie('locale');
  const deviceID = getCookie('deviceId');

  const initialAxios = createAPIInstance({
    baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  });

  initialAxios.interceptors.request.use((config) => {
    if (token) {
      config.headers.Authorization = token;
    }

    if (deviceID) config.headers['X-Device-Id'] = deviceID;

    config.headers['X-Language'] = locale;

    if (!config.params) config.params = {};
    config.params.clientType = 'website';

    return config;
  });

  const initialAPI = CreateAPI(initialAxios);

  return {
    API: initialAPI,

    setAPI: (newAPI: WrappedAPI) => set({ API: newAPI }),
  };
});
